<template>
  <div ref="appContent" class="app-body" style="padding-bottom: 80px;">
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :lg="8" :md="8" :xl="8">
          <el-form-item label="订单编号：" prop="orderCode">
            <order-drop v-model="dataForm.orderCode" placeholder="请输入外销合同编号" size="mini"></order-drop>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商：" prop="companyId">
            <company v-model="dataForm.companyId" size="mini"></company>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="交付日期：" prop="deadline">
            <el-date-picker
                v-model="dataForm.deadline"
                placeholder="选择日期"
                style="width: 100%;"
                type="date"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="收货方：" prop="storageIds">
        <CommonDrop
            ref="storage"
            v-model="storageIds"
            :autoDefault="false"
            :filterable="true"
            :multiple="true"
            :remote="true"
            size="mini"
            url="/trade/storages/list"
        ></CommonDrop>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark" :rows="6" resize="none" type="textarea"></el-input>
      </el-form-item>
      <div class="table-bar" style="justify-content: flex-start">
        <el-button :disabled="dataForm.orderCode?false:true" size="mini" type="primary"
                   @click="showOrderDetailDialog">
          {{ dataForm.orderCode ? '选择品番' : '请先选择关联订单' }}
        </el-button>

        <div style="display: flex;align-items: center;margin-left: 20px;">
          <div>损耗率：</div>
          <el-input-number v-model="rate" :max="1" :min="0" :precision="2" :step="0.01"></el-input-number>
        </div>
      </div>
      <div v-if="orderDetailList&&orderDetailList.length>0" class="table-bar"
           style="flex-wrap: wrap;margin: 0;margin-bottom: 10px;justify-content: flex-start;">
        <el-tag v-for="item in orderDetailList" :key="item.id" size="mini" style="margin: 6px 6px;">
          {{ $productName(item) }}
        </el-tag>
      </div>
      <el-table
          ref="table"
          :cell-style="{padding: '0'}"
          :data="dataForm.detailList"
          :max-height="400"
          border
      >
        <el-table-column
            align="center"
            header-align="center"
            label="行号"
            type="index"
            width="50"
        >
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="原料名称" prop="productName">
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            header-align="center"
            label="颜色"
            prop="color"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            header-align="center"
            label="规格"
            prop="size"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            header-align="center"
            label="幅宽"
            prop="attr1"
        >
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            header-align="center"
            label="克重"
            prop="attr2"
        >
        </el-table-column>
        <el-table-column
            align="center"
            header-align="center"
            label="原料数量"
            width="160"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0;"
            >
              <el-input v-model="scope.row.count" :tabindex="String((scope.$index+1)*10+1)" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            header-align="center"
            label="采购单价"
            width="160"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.price'"
                :rules="detailRule.price"
                label-width="0"
                style="margin-bottom: 0;"
            >
              <el-input v-model="scope.row.price" :tabindex="String((scope.$index+1)*10+2)" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
                icon="el-icon-remove"
                size="mini"
                type="text"
                @click="delRow(scope.$index, scope.row, 'date')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bar" style="margin-bottom: 0px;">
        <div style="margin-top:20px;font-size: 18px;font-weight: bold;">送货设置</div>
      </div>
      <el-tabs>
        <el-empty v-if="!dataForm.sendList||dataForm.sendList.length===0" :image-size="120"
                  description="请先选择接收方"></el-empty>
        <el-tabs v-model="currentTab" type="card">
          <el-tab-pane v-for="(item,tabIndex) in dataForm.sendList" :key="item.storageId" :label="item.storageName"
                       :name="item.storageId">
            <el-table
                ref="table2"
                :cell-style="{padding: '0'}"
                :data="item.dataList"
                :height="400"
                border
            >
              <el-table-column
                  align="center"
                  header-align="center"
                  label="行号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" align="center" label="原料名称" prop="productName">
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  header-align="center"
                  label="颜色"
                  prop="color"
              >
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  header-align="center"
                  label="规格"
                  prop="size"
              >
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  header-align="center"
                  label="幅宽"
                  prop="attr1"
              >
              </el-table-column>
              <el-table-column
                  :show-overflow-tooltip="true"
                  align="center"
                  header-align="center"
                  label="克重"
                  prop="attr2"
              >
              </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  label="送货数量"
                  width="160"
              >
                <template slot-scope="scope">
                  <el-form-item
                      :prop="'detailList.' + scope.$index + '.count'"
                      :rules="detailRule.count"
                      label-width="0"
                      style="margin-bottom: 0;"
                  >
                    <el-input v-model="scope.row.count" :tabindex="String((tabIndex+1)*10000+(scope.$index+1)*10+1)"
                              size="mini"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="center" header-align="center" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                      icon="el-icon-remove"
                      size="mini"
                      type="text"
                      @click="delSendRow(scope.$index, item.dataList)"
                  >
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tabs>
    </el-form>
    <div class="form-foot fixed">
      <el-button size="mini" @click="cancel()">{{
          $t('cancel')
        }}
      </el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle()">保存
      </el-button>
    </div>
    <order-detail-dialog ref="orderDetailDialog" @selected="orderDetailSelected"></order-detail-dialog>
  </div>
</template>

<script>
import OrderDetailDialog from '@/components/order-detail-dialog'
import debounce from 'lodash/debounce'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import CommonDrop from '@/components/CommonDrop'

export default {
  components: { OrderDetailDialog, CommonDrop },
  data () {
    return {
      rate: 0.00,
      id: '',
      dataForm: {},
      orderDetailList: [],
      storageIds: [],
      currentTab: ''
    }
  },
  watch: {
    rate: {
      handler: function (newVal) {
        if (!this.orderDetailList || this.orderDetailList.length === 0) {
          return
        }
        let ids = this.orderDetailList.map(item => item.id)
        this.readMaterialList(ids)
      },
      immediate: true
    },
    storageIds: {
      handler: function (newVal) {
        if (!newVal || newVal.length === 0) {
          this.currentTab = ''
          this.dataForm.storageIds = ''
          return []
        }
        this.dataForm.storageIds = newVal.join(',')
        let tmp = []
        let storageList = this.$refs.storage.dataList
        newVal.forEach(item => {
          let storage = storageList.find(s => s.id === item)
          if (!storage) {
            return
          }
          let exitObj = this.dataForm.sendList.find(s => s.storageId === item)
          if (exitObj) {
            tmp.push(exitObj)
          } else {
            let odl = []
            if (this.dataForm.detailList && this.dataForm.detailList.length > 0) {
              odl = this.dataForm.detailList.map(d => {
                return {
                  ...d,
                  count: 0
                }
              })
            }
            tmp.push({
              storageId: storage.id,
              storageName: storage.name,
              dataList: odl
            })
          }
        })
        if (!this.currentTab || this.currentTab == '0' || !newVal.find(n => n == this.currentTab)) {
          this.currentTab = newVal[0]
        }
        this.dataForm.sendList = tmp
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    dataRule () {
      return {
        orderCode: [
          { required: true, message: '请输入外销合同号', trigger: 'change' },
        ],
        companyId: [
          { required: true, message: '请选择供应商', trigger: 'change' },
        ],
        storageIds: [
          { required: true, message: '请选择收货方', trigger: 'change' }
        ],
      }
    },
    detailRule () {
      return {
        price: [
          { required: true, message: '请填写单价', trigger: 'change' },
          { validator: moneyValidator, trigger: 'change' },
        ],
        count: [
          { required: true, message: '请填写数量', trigger: 'change' },
          {
            validator: function (rule, value, callback) {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ],
      }
    },
  },
  activated () {
    this.id = this.$route.query.id
    this.reset()
  },
  mounted () {
  },
  methods: {
    // keyDown (e) {
    //   console.log('键盘安下了',e)
    //   if (e.keyCode === 120) {
    //     //this.$refs.multipleTable.store.states.selection
    //     //console.log(this.$refs.itsmDataTable.store.states)
    //     //console.log(this.$refs.itsmDataTable.store.states.currentRow)
    //     let array = this.tableData
    //     let current = this.$refs.itsmDataTable.store.states.currentRow
    //     // 找到current当前行的索引
    //     for (let i = 0, len = array.length; i < len; i++) {
    //       if (Object.entries(array[i]).toString() === Object.entries(current).toString()) {
    //         console.log('当前行索引', i)
    //         // 如果当前行不是倒数第一行，则修改下一行的name为当前行的值
    //         if (i < len - 1) {
    //           array[i + 1].name = array[i].name
    //           // 跳转到下一行
    //           this.$refs.itsmDataTable.setCurrentRow(array[i + 1])
    //           break
    //         }
    //       }
    //     }
    //   }
    // },
    showOrderDetailDialog () {
      this.$refs.orderDetailDialog.dataForm.agreementCode = this.dataForm.orderCode
      this.$refs.orderDetailDialog.init()
    },
    orderDetailSelected (e) {
      this.orderDetailList = e
      if (e && e.length > 0) {
        let ids = this.orderDetailList.map(item => item.id)
        this.readMaterialList(ids)
      }
    },
    readMaterialList (ids) {
      let loading = this.$loading()
      this.$http
          .post(`/purchase/material/list`, { orderDetailIds: ids.join(',') })
          .then(({ data: res }) => {
            loading.close()
            if (res.data) {
              res.data.forEach((item, index) => {
                item.id = index + 1
                item.price = 0
                item.count = new BigNumber(item.count).multipliedBy(new BigNumber(this.rate).plus(1)).toFixed(3)
              })
            }
            this.$set(this.dataForm, 'detailList', res.data)
            if (this.dataForm.sendList && this.dataForm.sendList.length > 0) {
              this.dataForm.sendList.forEach(item => {
                item.dataList = res.data.map(d => {
                  return {
                    ...d,
                    count: 0,
                  }
                })
              })
            }
          }).catch(e => {
        loading.close()
      })
    },
    delRow (index, row, dataKey) {
      this.dataForm.detailList.splice(index, 1)
    },
    delSendRow (index, dataList) {
      dataList.splice(index, 1)
    },
    reset () {
      this.rate = 0
      this.orderDetailList = []
      this.storageIds = []
      this.currentTab = ''
      this.dataForm = {
        id: '',
        remark: '',
        orderCode: '',
        agreementId: '',
        companyId: '',
        detailList: [],
        storageIds: '',
        deadline: '',
        sendList: []
      }
      if (this.id) {
        this.getInfo()
      }

      this.$nextTick(() => {
        if (this.$refs['dataForm']) {
          this.$refs['dataForm'].clearValidate()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/purchase/${this.id}`).then(({ data: res }) => {
        if (res.data) {
          if (res.data.detailList) {
            res.data.detailList = res.data.detailList.map(item => {
              return {
                ...item,
                color: item.productColor,
                size: item.productSize,
                attr1: item.productAttr1,
                attr2: item.productAttr2
              }
            })
          }
          let storageList = this.$refs.storage.dataList
          if (res.data.sendList) {
            this.storageIds = [...new Set(res.data.sendList.map(item => item.storageId))]
            let sTmp = []
            this.storageIds.forEach(sid => {
              let storage = storageList.find(s => s.id === sid)
              if (!storage) {
                return
              }
              sTmp.push({
                storageId: sid,
                storageName: storage.name,
                dataList: res.data.sendList.filter(s => s.storageId === sid).map(item => {
                  return {
                    ...item,
                    color: item.productColor,
                    size: item.productSize,
                    attr1: item.productAttr1,
                    attr2: item.productAttr2
                  }
                })
              })
            })
            res.data.sendList = sTmp
          }
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      })
    },
    cancel () {
      this.$router.back()
    },
    doSave (postForm) {
      const loading = this.$loading()
      this.$http
          .post('/purchase/save', postForm)
          .then(({ data: res }) => {
            loading.close()
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$c.success().then(() => {
              this.cancel()
            })
          })
          .catch((e) => {
            loading.close()
          })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            if (this.dataForm.detailList.length === 0) {
              return this.$message.error('原料明细不能为空')
            }
            let postForm = {
              ...this.dataForm
            }
            let tmpSendList = []
            postForm.sendList.forEach(item => {
              item.dataList.forEach(row => {
                tmpSendList.push({
                  productId: row.productId,
                  count: row.count,
                  storageId: item.storageId
                })
              })
            })
            postForm.sendList = tmpSendList
            this.doSave(postForm)
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>


